import { createServerFn } from "@tanstack/react-start";

import { getDeliverabilityDashboard, type DeliverabilityRange } from "./server";

function passthroughValidator<T>(value: T) {
  return value;
}

export const getDeliverabilityView = createServerFn({ method: "GET" })
  .validator(
    passthroughValidator<
      { range?: DeliverabilityRange; domainId?: string | null; aliasId?: string | null } | undefined
    >,
  )
  .handler(async ({ data }) => {
    return await getDeliverabilityDashboard({
      range: data?.range,
      domainId: data?.domainId ?? undefined,
      aliasId: data?.aliasId ?? undefined,
    });
  });
